import { combineReducers, configureStore } from '@reduxjs/toolkit';
import api from '../api/api';
import authSlice, { IauthInitState } from './authSlice';
import commonSlice, { ICommonInitState } from './commonSlice';
import userSlice, { IUserSliceInitState } from './userSlice';

export interface IInitReduxState {
  authSlice?: IauthInitState;
  commonSlice?: ICommonInitState;
  userSlice?: IUserSliceInitState;
}

const rootReducer = combineReducers({
  [api.reducerPath]: api.reducer,
  authSlice,
  commonSlice,
  userSlice,
});

// -- Redux store with initial state (for testing)
export const createReduxStore = (preloadedState?: IInitReduxState) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
    preloadedState: preloadedState || {},
  });

export const store = createReduxStore();

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
